const state = {
  invoiceData: null
}
export default state
